export type SchoolOverviewInfo = Record<string, string | number | null | undefined>;

export type DisclosureMetric = { key: string; label: string; value: number | string; unit: string };
export type DisclosureSection = {
  id: string;
  title: string;
  status: 'available' | 'unpublished' | 'excluded' | 'error' | 'separate';
  year: number | null;
  basis?: string | null;
  note: string;
  metrics: DisclosureMetric[];
  breakdown: Array<{ label: string; male?: number | null; female?: number | null; students: number | null; classes: number | null; average: number | null }>;
};
export type SchoolDisclosure = {
  status: 'available' | 'unmatched' | 'unsupported';
  sourceUrl: string;
  schoolName: string;
  sections: DisclosureSection[];
  homepage?: string;
  contacts?: { staffRoom: string; administration: string };
};

export type SchoolClasses = {
  academicYear: string;
  totalClasses: number;
  gradeCount: number;
  groups: Array<{ course: string; grade: string; department: string; dayNight: string; track: string; classes: string[] }>;
  updatedAt: string | null;
  source: string;
};

export function schoolValue(school: SchoolOverviewInfo, key: string) {
  const value = String(school[key] ?? school[key.toLowerCase()] ?? '').trim();
  return ['-', 'null', 'undefined'].includes(value) ? '' : value;
}

export function schoolDate(value: string, anniversary = false) {
  const compact = value.replace(/[-./]/g, '');
  if (!/^\d{8}$/.test(compact)) return '';
  const year = Number(compact.slice(0, 4));
  const month = Number(compact.slice(4, 6));
  const day = Number(compact.slice(6));
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
  return `${anniversary ? '' : `${year}년 `}${month}월 ${day}일`;
}

export function schoolHomepage(value: string) {
  if (!value || (/^[a-z][a-z\d+.-]*:/i.test(value) && !/^https?:\/\//i.test(value))) return null;
  try {
    const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
